<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户姓名" prop="cusName">
                        <Input
                            v-model="info.cusName"
                            :maxlength="100"
                            placeholder
                            readonly
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="客户手机号" prop="cusMobile">
                        <Input
                            v-model="info.cusMobile"
                            :maxlength="100"
                            placeholder
                            readonly
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="跟进情况" prop="trackStatus ">
                        <Select style="width: 276px" v-model="info.trackStatus">
                            <Option
                                v-for="item in trackStatusList"
                                :value="item.text"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="跟进人" prop="trackUser">
                        <Input
                            v-model="info.trackUser"
                            :maxlength="100"
                            readonly
                        ></Input>
                        <!-- <Select style="width:276px" v-model="info.trackUser">
              <Option v-for="item in trackUserList" :value="item.text" :key="item.id">{{ item.text}}</Option>
                        </Select>-->
                    </FormItem>
                </Col>
            </Row>
            -
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="跟进内容" prop="content">
                        <Input
                            v-model="info.content"
                            :maxlength="1000"
                            type="textarea"
                            placeholder="0-1000个字"
                            :rows="4"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>{{ id }}</Row>
        </Form>
    </div>
</template>
<script>
import { cInfoView, cTrackAdd } from '@/api/customer'
import Dict from '_u/dict'
import { tel } from '_u/validate'

export default {
    name: 'c-info-hfjl-form',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        cusId: {
            type: [String, Number],
            default: '',
        },
        cusName: {
            type: [String, Number],
            default: '',
        },
        cusMobile: {
            type: [String, Number],
            default: '',
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: '',
                cusId: this.cusId, // 客户数据编号
                cusName: this.cusName, //客户名称
                cusMobile: this.cusMobile, // 客户手机号码
                trackUser: this.$store.state.user.info.nickName, //跟进人
                content: '', //跟进内容
                trackStatus: '', // 跟进状态
            },

            dict: {
                trackStatus: Dict.NULL,
                cusSource: Dict.NULL,
            },
            cityList: [],
        }
    },

    computed: {
        ruleValidate() {
            return {
                cusName: [{ required: true, message: '客户名称必填' }],
                cusMobile: [
                    { required: true, message: '客户手机号必填' },
                    { validator: tel, message: '客户手机号格式不正确' },
                ], // 星号  验证方式  提示
            }
        },
        trackStatusList() {
            return this.dict.trackStatus.toList()
        },
        cusSourceList() {
            return this.dict.cusSource.toList()
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return cInfoView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(['track_status', 'cus_source']),
                this.fetch(),
            ])
                .then((args) => {
                    var [dictGroup, view] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    return cTrackAdd(formData)
                })
                .then((res) => {
                    if (res.code === 200) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
